import { useEffect, useState } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { MemberApi } from "../../api/MemberApi";
import MemberMonthlyPlayTimeChart from "./MemberMonthlyPlayTimeChart";
import { loadingSpinnerSx, mutedTextSx } from "../../styles/cyberTheme";

export default function MemberMonthlyPlayTimePanel({ memberID, year = "" }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!memberID) {
            setLoading(false);
            setData([]);
            return;
        }

        let cancelled = false;

        const load = async () => {
            setLoading(true);
            setError("");
            try {
                const result = await MemberApi.getMemberMonthlyPlayTimeStat(memberID, year);
                if (!cancelled) {
                    setData(Array.isArray(result) ? result : []);
                }
            } catch (e) {
                if (!cancelled) {
                    setError("無法載入月度參與數據");
                    setData([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        load();
        return () => {
            cancelled = true;
        };
    }, [memberID, year]);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress sx={loadingSpinnerSx} />
            </Box>
        );
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    if (!data || data.length === 0) {
        return (
            <Box sx={{ ...mutedTextSx, textAlign: "center", py: 4 }}>
                暫無月度參與數據
            </Box>
        );
    }

    return (
        <Box sx={{ height: "100%", minHeight: 200 }}>
            <MemberMonthlyPlayTimeChart data={data} />
        </Box>
    );
}
